import sessionStorageSingleton from '../../configs/sessionStorageSingleton';

type QueueItem = (value: unknown) => void;

export class LockMechanism {
  private locked: Map<string, true>;
  private Queue: Map<string, QueueItem[]>;

  constructor() {
    this.locked = new Map();
    this.Queue = new Map();
  }

  public async acquire(key: string) {
    while (this.locked.get(key)) {
      const workerWaitingPromise = new Promise((resolve) => {
        if (!this.Queue.get(key)) this.Queue.set(key, []);
        return this.Queue.get(key)?.push(resolve);
        // return lockQueue[id].push(resolve);
      });

      await workerWaitingPromise;
    }

    // lockFiles[id] = true;
    this.locked.set(key, true);
  }

  public async release(key: string) {
    this.locked.delete(key);
    const lockedQueue = this.Queue.get(key);
    if (lockedQueue && lockedQueue?.length > 0) {
      const resolveFirstInQueue = lockedQueue.shift();
      if (resolveFirstInQueue) resolveFirstInQueue('');
    } else {
      this.Queue.delete(key);
    }
  }
}

// export const acquireLock = async (acquiredItems: string[], id: string) => {
//   if (!acquiredItems.includes(id)) {
//     await sessionStorageSingleton.acquireLock(id);
//     acquiredItems.push(id);
//   }
// };

// export const releaseLock = async (acquiredItems: string[], id: string) => {
//   const indexToRemove = acquiredItems.indexOf(id);
//   if (indexToRemove !== -1) {
//     sessionStorageSingleton.releaseLock(id);
//     acquiredItems.splice(indexToRemove, -1);
//   }
// };

// export const releaseLocks = (acquiredItems: string[]) => {
//   for (let id of acquiredItems) {
//     releaseLock(acquiredItems, id);
//   }
// };

export const acquireRecord = async (
  id: string,
  type: 'd' | 'r' = 'r',
  userId = '',
  ifAvailable = true
) => {
  const key = `${userId ? `${userId}/` : ''}${id}`;
  const error = await sessionStorageSingleton.acquire(key, type, ifAvailable);
  if (error) throw new Error(error);
};
